import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DepotFacade } from '@zero/depot/domain';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';

@Component({
  imports: [TranslocoPipe, ButtonComponent, ModalComponent],
  templateUrl: './direct-debit-hint.component.html',
})
export class DirectDebitHintComponent {
  public readonly modal = inject(NgbActiveModal);
  readonly #depotFacade = inject(DepotFacade);

  public activateDirectDebit(): void {
    this.#depotFacade.activateDirectDebit();
    this.modal.close();
  }
}
